import { http } from '@/services'

export default {
    getPeriodicidade:() => {
        return http.get('util/periodicidade')
    },

    getStatus:() => {
        return http.get('util/status')
    },

    getTipoResidencia: () =>{
        return http.get('residencia/')
    },

    getTema: () =>{
        return http.get('tema/')
    }
}